// JWT bearer token storage. v1 auth is token-based (not cookie-based), so the
// token from POST /auth/login is persisted here and attached by apiClient's
// request interceptor. localStorage (per user decision) — survives reloads/tabs.

const TOKEN_KEY = "blogic:token";

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* storage unavailable (private mode / SSR) — ignore */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

const REFRESH_TOKEN_KEY = "blogic:refresh-token";

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setRefreshToken(token: string): void {
  try {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch {
    return;
  }
}

export function clearRefreshToken(): void {
  try {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    return;
  }
}

export function clearTokens(): void {
  clearToken();
  clearRefreshToken();
}
